import { render, staticRenderFns } from "./note.vue?vue&type=template&id=15b3fdb4&"
import script from "./note.vue?vue&type=script&lang=js&"
export * from "./note.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/nsdua/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15b3fdb4')) {
      api.createRecord('15b3fdb4', component.options)
    } else {
      api.reload('15b3fdb4', component.options)
    }
    module.hot.accept("./note.vue?vue&type=template&id=15b3fdb4&", function () {
      api.rerender('15b3fdb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/page/_home/note.vue"
export default component.exports